import { ESessionTemplate } from '../../enums/v2/session-template.enum';
import { ESessionType } from '../../enums/v2/session-type.enum';

const typeList = {
  [ESessionTemplate.CALL]: ESessionType.CALL,
  [ESessionTemplate.CHAT]: ESessionType.CHAT,
  [ESessionTemplate.HOME]: ESessionType.HISTORY,
};

export const typeMapper = (dynType: ESessionTemplate): ESessionType => {
  return typeList[dynType];
};
